import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, Footer } from '../../components/layout';
import { ArrowLeft } from 'lucide-react';
import { ToolbarButton } from '../../components/common';
import './Terms.css';

const TermsPage = () => {
  const navigate = useNavigate();
  const lastUpdated = '2025년 1월 25일';

  return (
    <div className="page-container-white">
      <Header />
      
      <main className="terms-content">
        <div className="terms-header">
          <ToolbarButton
            onClick={() => navigate(-1)}
            variant="default"
            className="mb-4"
          >
            <ArrowLeft className="w-4 h-4" />
            뒤로 가기
          </ToolbarButton>
          
          <h1 className="terms-title">이용약관</h1>
          <p className="terms-updated">최종 수정일: {lastUpdated}</p>
        </div>

        <div className="terms-body">
          <section className="terms-section">
            <h2>제1조 (목적)</h2>
            <p>
              본 약관은 Latte AI(이하 "서비스")가 제공하는 AI 기반 이력서 작성 서비스의 이용과 관련하여 
              서비스와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
            </p>
          </section>

          <section className="terms-section">
            <h2>제2조 (용어의 정의)</h2>
            <p>본 약관에서 사용하는 주요 용어의 정의는 다음과 같습니다.</p>
            <ul>
              <li>"서비스"란 Latte AI가 제공하는 AI 기반 이력서 작성 및 관련 부가 서비스를 의미합니다.</li>
              <li>"이용자"란 본 약관에 따라 서비스를 이용하는 회원을 의미합니다.</li>
              <li>"회원"이란 서비스에 접속하여 본 약관에 따라 서비스 이용계약을 체결하고 서비스를 이용하는 고객을 의미합니다.</li>
              <li>"AI 컨설팅"이란 인공지능 기술을 활용하여 이용자의 경력 정보를 분석하고 이력서 작성을 지원하는 서비스를 의미합니다.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>제3조 (약관의 효력 및 변경)</h2>
            <ol>
              <li>본 약관은 서비스를 이용하고자 하는 모든 이용자에게 그 효력을 발생합니다.</li>
              <li>서비스는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있습니다.</li>
              <li>약관이 변경되는 경우 서비스는 변경사항을 시행일자 최소 7일 전부터 서비스 내 공지사항을 통해 고지합니다.</li>
              <li>변경된 약관에 대해 이의가 있는 이용자는 회원탈퇴를 할 수 있으며, 시행일 이후 계속 서비스를 이용하는 경우 약관 변경에 동의한 것으로 간주합니다.</li>
            </ol>
          </section>

          <section className="terms-section">
            <h2>제4조 (서비스의 제공)</h2>
            <p>서비스는 다음과 같은 서비스를 제공합니다.</p>
            <ul>
              <li>AI 기반 이력서 작성 컨설팅</li>
              <li>이력서 템플릿 제공 및 편집 기능</li>
              <li>PDF 형식의 이력서 다운로드</li>
              <li>온라인 웹 페이지 생성 및 관리</li>
              <li>기타 서비스가 정하는 부가 서비스</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>제5조 (회원가입)</h2>
            <ol>
              <li>이용자는 서비스가 정한 가입 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.</li>
              <li>서비스는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.
                <ul>
                  <li>가입신청자가 본 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
                  <li>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
                  <li>기타 회원으로 등록하는 것이 서비스의 기술상 현저히 지장이 있다고 판단되는 경우</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="terms-section">
            <h2>제6조 (회원정보의 변경)</h2>
            <p>
              회원은 회원가입 시 기재한 사항이 변경되었을 경우 즉시 해당 사항을 수정해야 하며, 
              변경하지 않아 발생하는 불이익에 대해서는 서비스가 책임지지 않습니다.
            </p>
          </section>

          <section className="terms-section">
            <h2>제7조 (서비스 이용시간)</h2>
            <ol>
              <li>서비스의 이용시간은 연중무휴, 1일 24시간을 원칙으로 합니다.</li>
              <li>다만, 서비스의 업무상 또는 기술상 특별한 지장이 없는 한 정기점검 등의 필요로 인하여 서비스가 정한 날이나 시간은 예외로 합니다.</li>
              <li>정기점검시간은 서비스 제공화면에 공지한 바에 따릅니다.</li>
            </ol>
          </section>

          <section className="terms-section">
            <h2>제8조 (서비스의 중단)</h2>
            <ol>
              <li>서비스는 다음 각 호에 해당하는 경우 서비스 제공을 중단할 수 있습니다.
                <ul>
                  <li>서비스용 설비의 보수 등 공사로 인한 부득이한 경우</li>
                  <li>전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우</li>
                  <li>천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우</li>
                </ul>
              </li>
              <li>서비스는 제1항의 사유로 서비스 제공이 중단되는 경우 이를 사전에 공지합니다. 다만, 불가피한 사유로 사전 공지가 불가능한 경우에는 사후에 공지합니다.</li>
            </ol>
          </section>

          <section className="terms-section">
            <h2>제9조 (이용자의 의무)</h2>
            <p>이용자는 다음 행위를 하여서는 안 됩니다.</p>
            <ul>
              <li>타인의 정보도용</li>
              <li>서비스에 게시된 정보의 변경</li>
              <li>서비스가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
              <li>서비스 및 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
              <li>서비스 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
              <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위</li>
              <li>서비스의 안정적인 운영을 방해할 수 있는 정보를 전송하거나 수신하는 행위</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>제10조 (저작권의 귀속)</h2>
            <ol>
              <li>서비스가 제공하는 서비스에 대한 저작권 및 지적재산권은 서비스에 귀속됩니다.</li>
              <li>이용자가 서비스를 이용하여 생성한 이력서 및 콘텐츠의 저작권은 해당 이용자에게 귀속됩니다.</li>
              <li>이용자는 서비스를 이용함으로써 얻은 정보 중 서비스에게 지적재산권이 귀속된 정보를 서비스의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.</li>
            </ol>
          </section>

          <section className="terms-section">
            <h2>제11조 (개인정보보호)</h2>
            <p>
              서비스는 이용자의 개인정보를 중요시하며, 개인정보보호법 등 관련 법령을 준수합니다. 
              개인정보의 수집, 이용, 보호에 관한 사항은 별도의 개인정보처리방침에서 정합니다.
            </p>
          </section>

          <section className="terms-section">
            <h2>제12조 (면책조항)</h2>
            <ol>
              <li>서비스는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
              <li>서비스는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
              <li>서비스는 이용자가 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖의 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.</li>
              <li>서비스는 이용자가 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.</li>
            </ol>
          </section>

          <section className="terms-section">
            <h2>제13조 (분쟁해결)</h2>
            <ol>
              <li>서비스는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.</li>
              <li>서비스는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보합니다.</li>
            </ol>
          </section>

          <section className="terms-section">
            <h2>제14조 (재판관할)</h2>
            <p>
              서비스와 이용자 간에 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다.
            </p>
          </section>

          <section className="terms-section">
            <h2>부칙</h2>
            <p>본 약관은 {lastUpdated}부터 시행됩니다.</p>
          </section>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsPage;